import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Card, Modal, Col, Radio, Image, Row, Table, Typography, notification, Space, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    CheckCircleTwoTone,
    LockFilled,
    UnlockFilled,
    EyeFilled,
    EditFilled,
    LinkOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import Text from 'antd/es/typography/Text';
import Parameters from 'shared/parameters';
import { split } from 'apollo-boost';

import arrowLeft from '../../../src/img/arrow-left.png';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';
import lockOpen from '../../../src/img/lock-open.png';
import viewIcon from '../../../src/img/view-icon.png';
import editIcon from '../../../src/img/edit-icon.png';
import plusIcon from '../../../src/img/plus.png';
import deFlag from '../../../src/img/de-icon.png';
// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
export default function UsersPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [deletingItem, setDeletingItem] = useState(false);
    const [activeTab, setActiveTab] = useState(Parameters.Mode === 'SUPER_ADMIN' ? 'ADMIN' : 'STUDENT');
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    // const [searchInput, setSearchInput] = useState('');
    // const [filteredResults, setFilteredResults] = useState([] as any[]);
    // const searchItems = (searchValue:any) => {
    //     console.log(searchValue)
    //     setSearchInput(searchValue)
    //     if (searchValue !== '') {
    //         const filteredData = items.filter((item) => {
    //             return Object.values(item.name).join('').toLowerCase().includes(searchValue.toLowerCase())
    //         })
    //          console.log(filteredData)
    //          setFilteredResults(filteredData)
    //     }
    //     else{
    //          setFilteredResults(items)
    //     }
    // }
    const columns = [
        {
            title: t('genDict.name'),
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: t('genDict.email'),
            key: 'email',
            dataIndex: 'email',
        },
        {
            title: t('genDict.gender'),
            key: 'gender',
            dataIndex: 'gender',
            render: (a: string) => a ? <Text>{t('genDict.' + a)}</Text> : '-',
        },

        {
            title: t('genDict.phone'),
            key: 'phone',
            dataIndex: 'phone',
        },
        {
            title: t('genDict.type'),
            key: 'type',
            render: (a: any) => <Text>{a.role_id === 3 ? 'INSTRUCTOR' : (a.role_id === 2 ? 'ADMIN' : 'STUDENT')}</Text>,
        },
        {
            title: t('genDict.status'),
            key: 'status',
            dataIndex: 'status',
        },

        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    {
                        a.status === 'INACTIVE' ?
                            <Button danger shape={'circle'} type={'primary'} onClick={() => {
                                API_SERVICE.activateUser(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } icon={<LockFilled />} /> :
                            <Button shape={'circle'} type={'primary'} onClick={() => {
                                API_SERVICE.deactivateUser(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } className={'success-button '} icon={<UnlockFilled />} />
                    }
                    <Button type='default' shape='circle' icon={<EyeFilled />}
                            onClick={() => {
                                history.push(`/admins/${a.id}/view`);
                            }} />
                    <Button type='default' shape='circle' icon={<EditFilled />}
                            onClick={() => {
                                history.push(`/admins/${a.id}/edit`);
                            }} />
                    <Button type='primary' danger={true} shape='circle' icon={<DeleteOutlined />}
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined />,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${a.name}"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeUser(a.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        refreshItems();
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                            } />
                </Space>;
            },
        },
    ];
    if (Parameters.Mode === 'SUPER_ADMIN') {
        columns.splice(3, 0, {
                title: t('genDict.organization'),
                key: 'organization',
                dataIndex: 'organization',
                render: (a: any) => a ? a.name : '-',

            },
        );
    }
    const refreshItems = async () => {
        try {
            setFetching(true);
            const params: any = { order_by: 'id', page: 1, order: 'DESC' };
            if (activeTab === 'STUDENT') {
                params['type'] = 'student';
            } else if (activeTab === 'INSTRUCTOR') {
                params['type'] = 'instructor';
            }  else {
                params['type'] = 'Admin';
            }
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchUsers(params);
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#userList').DataTable();
                // } ,1000);
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
    }, [activeTab]);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <div className={'list-page-wrapper'}>
            <div className="container-fluid">
                <div className='row mb-3'>
                    <div className='col-sm-6 p-0 d-flex align-items-center'>
                        <div className='mr-4'>
                        <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                        </div>
                        <div><h3 className='mb-0'>{t('genDict.admins')}</h3></div>
                    </div>
                    <div className='col-sm-6 text-sm-right'>
                        <Button className="btn btn-blue text-capitalize" onClick={() => history.push('admins/create')}>
                            <span className='d-flex align-items-center'><img src={plusIcon} className="mr-1"/>{t('genDict.add')+' admin'}</span>
                        </Button>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 p-0'>
                        <div className='bg-white p-3 br-5px'>
                            <div className="row mt-2">
                                
                                {/* <div className='col-lg-12 mb-2'>
                                    <h4 className='float-left'>{t('genDict.admins')}</h4>
                                    <div className='float-right d-flex align-items-center' style={{flexWrap:'nowrap'}}>
                                        <span className='mr-2' style={{whiteSpace:'nowrap'}}>Search Admin</span>  
                                        <input type='text' name="" id="" onChange={(e) => searchItems(e.target.value)} placeholder='Enter Admin Name' className='form-control'/>
                                    </div>
                                </div> */}
                            <div className="col-md-12 pb-3">
                                <div className="table-responsive table-br-5 box-shadow mt-2">
                                    <table id='userList' className="table  table-meetings table-report">
                                    <thead>
                                        <tr>
                                        <th className="text-uppercase text-secondary">Admin Name</th>
                                        <th className="text-uppercase text-secondary">Email</th>
                                        <th className="text-uppercase text-secondary">Phone</th>
                                        <th className="text-uppercase text-secondary">Gender</th>
                                        <th className="text-uppercase text-secondary">Organization</th>
                                        <th className="text-uppercase text-secondary">Type</th>
                                        <th className="text-uppercase text-secondary text-center">Status</th>
                                        <th className="text-uppercase text-secondary" style={{width:'150px'}}>Added In</th>
                                        <th className="text-uppercase text-secondary" style={{width:'100px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            // searchInput.length > 1 ?
                                            // filteredResults && filteredResults.map(filtureddata => {
                                            //     return <tr>
                                            // <td>
                                            // <div className="d-flex align-items-center">
                                            //     <div className="mr-3">
                                            //     {filtureddata.avatar_image !== null ?
                                            //         <img src={Parameters.ImageBaseUrl + filtureddata.avatar_image.name} className="uploaded-img-cat" height="40" width="40"/>
                                            //         :
                                            //         <img src={Parameters.ImageBaseUrl + 'avatar.png'} className="uploaded-img-cat" height="40" width="40"/>
                                            //     }
                                            //     </div>
                                            //     <div className="">
                                            //         <p className="mb-0"><span>{filtureddata.name}</span></p>
                                            //     </div>
                                            //     </div>
                                            // </td>
                                            // <td className="text-secondary">{filtureddata.email}</td>
                                            // <td className="text-secondary">{filtureddata.phone}</td>
                                            // <td className="text-secondary">{filtureddata.gender}</td>
                                            // <td className="text-secondary">
                                            // {filtureddata.organization !== null ?
                                            //     filtureddata.organization.name
                                            //     :
                                            //     ''
                                            // }
                                            // </td>
                                            // <td className="text-secondary">
                                            //     {filtureddata.role_id === 1 ? 'Super Admin' : filtureddata.role_id === 2 ? 'Admin' : filtureddata.role_id === 3 ? 'Instructor' : filtureddata.role_id === 4 ? 'Student' : ''}
                                            // </td>
                                            // <td className="text-center">{filtureddata.status === 'ACTIVE' ? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                            // <td className="text-secondary">{moment(filtureddata.created_at).format('DD MMMM, YYYY')}</td>
                                            // <td className="text-secondary">
                                            //     <div className='d-flex align-items-center'>
                                            //         <div className='mr-3'>
                                            //         {
                                            //             filtureddata.status === 'INACTIVE' ?
                                            //                 <Button className='btn-none-danger' onClick={() => {
                                            //                     API_SERVICE.activateUser(filtureddata.id).then(() => {
                                            //                         refreshItems();
                                            //                     }).catch((e) => {
                                            //                         notification.error({ message: API_SERVICE.handleErrors(e) });
                                            //                     });
                                            //                 }
                                            //                 } icon={<LockFilled />} /> :
                                            //                 <Button className='btn-none-success' onClick={() => {
                                            //                     API_SERVICE.deactivateUser(filtureddata.id).then(() => {
                                            //                         refreshItems();
                                            //                     }).catch((e) => {
                                            //                         notification.error({ message: API_SERVICE.handleErrors(e) });
                                            //                     });
                                            //                 }
                                            //                 } icon={<UnlockFilled />} />
                                            //         }
                                            //             {/* <img className='cursor-pointer' src={lockOpen} style={{width:'15px'}} /> */}
                                            //         </div>
                                            //         <div className='mr-3'>
                                            //             <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                            //             onClick={() => {
                                            //                 history.push(`/admins/${filtureddata.id}/view`);
                                            //             }}
                                            //             />
                                            //         </div>
                                            //         <div className='mr-3'>
                                            //             <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                            //             onClick={() => {
                                            //                 history.push(`/admins/${filtureddata.id}/edit`);
                                            //             }}
                                            //             />
                                            //         </div>
                                            //     </div>
                                            // </td>
                                            // </tr>
                                            // })
                                            // :
                                        items && items.map(item => {
                                            console.log(item);
                                            return <tr>
                                            <td>
                                            <div className="d-flex align-items-center">
                                                <div className="mr-3">
                                                {item.avatar_image !== null ?
                                                    <img src={Parameters.ImageBaseUrl + item.avatar_image.name} className="uploaded-img-cat" height="40" width="40"/>
                                                    :
                                                    <img src={Parameters.ImageBaseUrl + 'avatar.png'} className="uploaded-img-cat" height="40" width="40"/>
                                                }
                                                </div>
                                                <div className="">
                                                    <p className="mb-0"><span>{item.name}</span></p>
                                                </div>
                                                </div>
                                            </td>
                                            <td className="text-secondary">{item.email}</td>
                                            <td className="text-secondary">{item.phone}</td>
                                            <td className="text-secondary">{item.gender}</td>
                                            <td className="text-secondary">
                                            {item.organization !== null ?
                                                item.organization.name
                                                :
                                                ''
                                            }
                                            </td>
                                            <td className="text-secondary">
                                            {item.role_id === 1 ? 'Super Admin' : item.role_id === 2 ? 'Admin' : item.role_id === 3 ? 'Instructor' : item.role_id === 4 ? 'Student' : ''}
                                            </td>
                                            <td className="text-center">{item.status === 'ACTIVE' ? <img src={activeBadge}/>: <img src={inactiveBadge}/>}</td>
                                            <td className="text-secondary">{moment(item.created_at).format('DD MMMM, YYYY')}</td>
                                            <td className="text-secondary">
                                                <div className='d-flex align-items-center'>
                                                    <div className='mr-3'>
                                                    {
                                                        item.status === 'INACTIVE' ?
                                                            <Button className='btn-none-danger' onClick={() => {
                                                                API_SERVICE.activateUser(item.id).then(() => {
                                                                    refreshItems();
                                                                }).catch((e) => {
                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                });
                                                            }
                                                            } icon={<LockFilled />} /> :
                                                            <Button className='btn-none-success' onClick={() => {
                                                                API_SERVICE.deactivateUser(item.id).then(() => {
                                                                    refreshItems();
                                                                }).catch((e) => {
                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                });
                                                            }
                                                            } icon={<UnlockFilled />} />
                                                    }
                                                        {/* <img className='cursor-pointer' src={lockOpen} style={{width:'15px'}} /> */}
                                                    </div>
                                                    <div className='mr-3'>
                                                        <img className='cursor-pointer' src={viewIcon} style={{width:'20px'}} 
                                                        onClick={() => {
                                                            history.push(`/admins/${item.id}/view`);
                                                        }}
                                                        />
                                                    </div>
                                                    <div className='mr-3'>
                                                        <img className='cursor-pointer' src={editIcon}  style={{width:'15px'}} 
                                                        onClick={() => {
                                                            history.push(`/admins/${item.id}/edit`);
                                                        }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
